import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MymeTypeIcon from '../../../../MymeTypeIcon';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { getIsNodeFile, getIsNodeFolder, getNodeMimeType } from 'utils';
import { isMaximumSelected } from 'router/subrouters/DataRoom/utils';

import './FileInfo.styles.scss';

type FileInfoProps = {
  className?: string;
  nodes?: DataRoomNode[];
};

const FileInfo: React.FC<FileInfoProps> = (props) => {
  const { className, nodes } = props;

  const isSingleFile = nodes.length === 1;

  const classes = classNames(
    'file-info',
    'white-panel',
    { 'file-info--single-file': isSingleFile },
    className,
  );

  const { t } = useTranslation();

  const selectedLabel = useMemo(() => {
    if (!nodes.length) return null;

    if (nodes.every(getIsNodeFile)) return 'numberOfFiles';

    if (nodes.every(getIsNodeFolder)) return 'numberOfFolders';

    return 'numberOfItems';
  }, [nodes]);

  if (isSingleFile)
    return (
      <div className={classes}>
        <MymeTypeIcon
          mimeType={getNodeMimeType(nodes[0])}
          isLocked={isMaximumSelected(nodes[0]?.fileSecurity)}
        />
        <p>{nodes[0].name}</p>
      </div>
    );

  return (
    <CollapsibleSection
      className={classes}
      trigger={<p>{t(selectedLabel, { count: nodes.length })}</p>}
    >
      <ul>
        {nodes.map(({ _id, name }) => (
          <li key={_id}>{name}</li>
        ))}
      </ul>
    </CollapsibleSection>
  );
};

export default FileInfo;
